"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _icon = _interopRequireDefault(require("../../components/icon"));
var _buttonModule = _interopRequireDefault(require("./button.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcButton(props) {
  var className = props.className,
    onClick = props.onClick,
    label = props.label,
    type = props.type,
    disabled = props.disabled,
    icon = props.icon,
    loading = props.loading,
    htmlType = props.htmlType;
  return icon ? /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    className: "".concat(_buttonModule["default"].buttonBox, " ").concat(className, " ").concat(type === 'primary' ? _buttonModule["default"].btn : ''),
    htmlType: htmlType,
    onClick: onClick && onClick,
    icon: /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      name: icon,
      size: {
        width: 13,
        height: 13
      }
    }),
    disabled: disabled ? disabled : false,
    loading: loading ? loading : false,
    type: type
  }, label ? label : 'Button') : /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    className: "".concat(className, " ").concat(type === 'primary' ? _buttonModule["default"].btn : ''),
    onClick: onClick && onClick,
    htmlType: htmlType,
    disabled: disabled ? disabled : false,
    loading: loading ? loading : false,
    type: type
  }, label ? label : 'Button');
}
var _default = ArcButton;
exports["default"] = _default;